import { useGetAppDataPermissionsStatusSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';

export function useShowDataPermissions(
  hasDataPermissions: boolean | undefined
): boolean | undefined {
  const { appId } = useApp();
  const skip = hasDataPermissions !== undefined;

  const { data } = useGetAppDataPermissionsStatusSuspenseQuery({
    variables: { appId },
    skip,
  });

  return skip ? hasDataPermissions : data?.hasDataPermissions;
}
